export type DomainMonitorModalType = 'edit' | 'delete' | 'pause' | 'resume' | 'tags' | 'limit' | null;

export type DomainMonitorBackgroundKind = 'en' | 'ok' | 'paused';

export function getDomainMonitorDateFormat(isEnglish: boolean): string {
    return isEnglish ? 'YYYY-MM-DD' : 'DD.MM.YYYY';
}

export function getDomainIncidentExpireFormat(isEnglish: boolean): string {
    return isEnglish ? 'YYYY-MM-DD, in HH:mm' : 'DD.MM.YYYY, в HH:mm';
}

export function getDomainMonitorBackgroundKind(active: boolean, isEnglish: boolean): DomainMonitorBackgroundKind {
    if (isEnglish) {
        return 'en';
    }

    return active ? 'ok' : 'paused';
}

export function getDomainRobotsTxtUrl(protocol: string, domain: string | null | undefined): string | null {
    return domain ? `${protocol}//${domain}/robots.txt` : null;
}
